// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-sV3P","screenshot":"screenshot-TEm3","message":"message-kJC2"};